import React, { Dispatch, FC, useCallback } from 'react';
import { Col } from 'reactstrap';
import { Option, OptionDataValue } from '../../../../shared/options';
import { ProductOptionInput } from '../../../../shared/orders';
import { VolunteerUpsertModel } from '../../../../shared/volunteer';
import { ProductOptionViewer } from '../../../components';
import { FormActionType } from '../../form/FormReducer';

interface VolunteerOptionProps {
  readonly required: boolean;
  readonly state: VolunteerUpsertModel;
  readonly dispatch: Dispatch<FormActionType>;
  readonly option: Option;
  readonly disabled: boolean;
}

export const VolunteerOption: FC<VolunteerOptionProps> = ({
  required,
  option,
  state,
  disabled,
  dispatch,
}) => {
  const setOptionValue = useCallback(
    (id: number, value: OptionDataValue) => {
      dispatch({
        type: 'updateVolunteerOption',
        optionId: id,
        value,
      });
    },
    [dispatch],
  );

  // TODO: Convert PO viewer into more generic component jesus
  const convertedOption: ProductOptionInput = {
    ...option,
    productOptionId: -1,
    required,
    mutable: true,
  };

  const value = state.options![option.id] as OptionDataValue;

  if (option.type === 'address') {
    return (
      <Col className="mb-1" key={option.id} xs={12}>
        <ProductOptionViewer
          defaultValue={value}
          disabled={disabled}
          onChange={setOptionValue}
          option={convertedOption}
        />
      </Col>
    );
  }

  return (
    <Col className="mb-1" key={option.id} xs={12}>
      <ProductOptionViewer
        defaultValue={value}
        disabled={disabled}
        onChange={setOptionValue}
        option={convertedOption}
      />
    </Col>
  );
};
